import { IJobListResponse } from "../interfaces/Job";
import { useAppQuery } from "./useAppQuery";

interface Props {
  name: string;
  enabled?: boolean;
}

export const useGetIndustryStandardJob = ({ name, enabled }: Props) => {
  const { data, isLoading } = useAppQuery<IJobListResponse, Error>("/StandardLibrary/jobs", {
    config: {
      params: {
        searchText: name,
        pageSize: 50
      }
    },
    enabled: enabled,
  });

  return { jobStandardLibrary: data?.jobDefinitions?.data, isLoading };
};
